import React, { Component } from 'react'
import { Helmet } from 'react-helmet'

import Home from '../components/Home'

class Index extends Component {
  componentDidMount() {
    const { bodyClasses } = this.props

    document.body.classList.remove('menu--opened', 'single', 'page', 'error-404')
    bodyClasses.forEach(bodyClass => document.body.classList.add(bodyClass))
  }
  componentWillUnmount() {
    const { bodyClasses } = this.props

    if (window.location.pathname !== '/') {
      bodyClasses.forEach(bodyClass => document.body.classList.remove(bodyClass))
    }
  }
  render() {
    const { handleInitialSlide, history, initialSlide, mainSlider, siteTitle, trips } = this.props

    return (
      <div>
        <Helmet>
          <title>{siteTitle}</title>
        </Helmet>
        <Home
          history={history}
          mainSlider={mainSlider}
          handleInitialSlide={handleInitialSlide}
          initialSlide={initialSlide}
          trips={trips}
        />
      </div>
    )
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/pages/Index.js